import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    dark: false,
    themes: {
      light: {
        primary: "#1976D2",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        onhover: "#eeeeee",
        background: "#F5F5F5",
        backgroundalt: "#F2F2F2",
      },
      dark: {
        primary: "#1976D2", // Se queda así - Dark Blue
        secondary: "#FFB74D", // Se queda así - saturated orange
        accent: "#6991D1", // Cambiemos a #6991D1 darker accent)
        error: "#FF5252", // Se queda igual
        info: "#64B5F6", // lighter blue than primary
        success: "#81C784", // A slightly lighter success color
        warning: "#FFD54F", // A slightly lighter warning color
        onhover: "#6991D1",
        background: "#424242",
      },
    },
  },
});
